import {
    QUERY_IS_LOADING,
    QUERY_NOT_LOADING,
    REQUEST_EVENTS,
    REQUEST_FILTERS
} from '../types';

const initialState = {
    filters:{
        categories:[],
        organizers:[],
    },
    queryIsLoading:false,
    events:[]
}

export default function(state = initialState, action) {
    switch(action.type) {
        case QUERY_IS_LOADING:
            return {
                ...state,
                queryIsLoading:true
            }
        case QUERY_NOT_LOADING:
            return {
                ...state,
                queryIsLoading:false
            }
        case REQUEST_EVENTS:
            return {
                ...state,
                events:action.payload
            }
        case REQUEST_FILTERS:
            return {
                ...state,
                filters:{
                    categories:action.payload.categories,
                    organizers:action.payload.companies
                }
            }
        default:
            return state;
    }
}